export default __webpack_public_path__ + "static/media/Direct-fired-boiler.e0979599.jpg";